// extracted by mini-css-extract-plugin
export default {"root":"Form_root__2nGzZ","isTabled":"Form_isTabled__KuVTx","isMobile":"Form_isMobile__xjcg5","heplerText":"Form_heplerText__KzfD9"};